import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["INSTANCE_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["INSTANCE_MODULE"],
  },
];

export default routes;
